import { usePrivacy } from 'apps/exegesis/utils/usePrivacy';
import React from 'react';
import styled from 'styled-components';
import { RandomWidgetProps, WidgetUtilityProps } from './WidgetWrapper';

export const RandomWidget = (props: RandomWidgetProps & WidgetUtilityProps) => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const privacy = usePrivacy();
  return (
    <>
      <h3>Random Widget</h3>
    </>
  );
};
